interface StatCardProps {
  title: string;
  value: string | number;
  valueSuffix?: string;
}

const StatCard = ({ title, value, valueSuffix }: StatCardProps) => {
  return (
    <div className="bg-background-dark-subdued rounded-lg shadow-lg p-8 w-full h-full border border-stroke-on-dark-subdued">
      <div className="flex flex-col">
        <div className="mb-2">
          <span className="text-gray-400 text-sm font-medium">{title}</span>
        </div>
        <div>
          <div className="text-white text-3xl font-bold">
            {value}
            {valueSuffix}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
